const playWhenVisible = function(item, slider){
	const Obs = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if(!entry.isIntersecting){
				slider.pause();
			}
			else {
				slider.play();
			}
		});
	}, {
		root: null,
		rootMargin: '0px',
		threshold: 0.3
	});
	Obs.observe($(item).closest('.tns-outer')[0]);
};

const localStorageTheme = localStorage.getItem("theme");
const systemSettingDark = window.matchMedia("(prefers-color-scheme: dark)");
let currentThemeSetting = calculateSettingAsThemeString(localStorageTheme, systemSettingDark);
updateThemeOnHtmlEl(currentThemeSetting);
updateButton(currentThemeSetting === "dark");

$(document).ready(() => {

	const setVh = () =>{
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
	setVh();

	let resizeTimeout;

	const resize = () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			setVh();
		}, 150);
	}

	window.addEventListener('resize', resize);
	window.addEventListener('orientationchange', resize);
	window.addEventListener('scroll', resize);


	let lastHeight = window.innerHeight;
	const monitorHeight = () => {
		const currentHeight = window.innerHeight;
		if (currentHeight !== lastHeight) {
			lastHeight = currentHeight;
			setVh();
		}
		requestAnimationFrame(monitorHeight);
	};
	monitorHeight();


	const $body = $('body');

	$("[data-mask]").each(function () {
		const type = $(this).data("mask");
		switch (type) {
			case "phone":
				$(this).inputmask({
					showMaskOnHover: false,
					mask: "+\\9\\94 * ### ## ##",
					/*oncomplete: function () {
						const p = $(this).parent();//
						if (!p.find("i.success").length)
							$("<i/>").addClass("success").appendTo(p);
						p.addClass("success");
					},
					onincomplete: function () {
						$(this).parent().removeClass("success");
					},*/
					onBeforeMask:function(value){
						value = value.replace(new RegExp(/[^0-9]/,'gi'),'');
						if(value.length === 12 && value.substring(0,3)==='994')value = value.substring(3);
						return value;
					},
					definitions: {
						"#": {
							validator: "[0-9]",
							cardinality: 1,
							casing: "lower",
						},
						"*": {
							validator: "(10|50|51|55|60|70|77|99)",
							cardinality: 2,
							prevalidator: [{validator: "[15679]", cardinality: 1}],
						},
					},
				});
				break;
			case "numeric":
			case "integer":
				$(this).inputmask(type, {rightAlign: false});
				break;
			case "cur":
				$(this).inputmask({
					suffix: " " + $(this).data("currency"),
					groupSeparator: ",",
					alias: "numeric",
					placeholder: "0",
					autoGroup: !0,
					digits: 2,
					digitsOptional: !1,
					clearMaskOnLostFocus: !1,
					rightAlign: false,
				});
				break;
		}
	});

	Fancybox.bind("[data-fancybox]");
	['.play','.video','a[href*="youtube"]','a[href*="youtu.be"]'].forEach(function(i,el){
		Fancybox.bind(i, {
			Html: {
				youtube: {
					nocookie: 0,
				},
			},
		});
	});

	$('body').on('change', '.file input[type="file"]', function (e) {
		const $this = $(this);
		$this.closest('.file').attr('data-label', $this.val().split('\\').pop());
	});

	$('.search-block button.filter').click(function (e) {
		e.preventDefault();
		e.stopPropagation();
		$('.search-block .bottom').toggleClass('active');
	});



	$(window).scroll(function () {
		if ($(window).scrollTop() > 1) {
			$("#header").addClass("fixed");
		} else {
			$("#header").removeClass("fixed");
		}
	});



	$('#header .theme-toggle').click(function (e) {
		const newTheme = currentThemeSetting === "dark" ? "light" : "dark";
		localStorage.setItem("theme", newTheme);
		updateButton(newTheme === "dark");
		updateThemeOnHtmlEl(newTheme);
		currentThemeSetting = newTheme;
	});

	$('#header .menu-toggle').click(function (e) {
		$('#header .rs').toggleClass('active');
		$('body').toggleClass('disable-scroll');
	});

	const media = window.matchMedia("(max-width: 832px)");
	mobileSupport(media);
	media.addEventListener('change', mobileSupport);

	if(!$.isMobile){
		$('.search-block .field select').select2({minimumResultsForSearch:100, dropdownCssClass: 'select2--search-block'});
		$('.search-block .bottom .types select').select2({minimumResultsForSearch:100, dropdownCssClass: 'select2--search-block', dropdownAutoWidth:true});
	}
	else{
		$('.partners .filter .title2').click(function (e) {
			e.preventDefault();
			e.stopPropagation();
			$('.partners .types').toggleClass('active');
		});
	}

	if ($(".blog-others .slider").length) {
		$(".blog-others .slider").each(function(){
			const slider = tns({
				container: this,
				gutter: 20,
				items: 1.2,
				controlsText: ["", ""],
				nav: false,
				loop: true,
				edgePadding: 0,
				autoplay: true,
				autoplayButtonOutput:false,
				autoplayHoverPause:true,
				responsive: {
					500: {
						items: 2,
						gutter: 20,
					},
					768: {
						items: 1,
					},
					900: {
						items: 2,
					},
					1180: {
						items: 2.5
					}
				}
			});
			playWhenVisible(this, slider);
		});
	}

	if ($(".faq-question").length){
		$(".faq-question header").on("click", function(){
			const t = $(this).closest('.faq-question');
			if(t.hasClass('active'))t.removeClass('active');
			else{
				$(".faq-question.active").removeClass('active');
				t.addClass('active');
			}
		})
	}
	if ($(".course-detail .curriculum ul li").length){
		$(".course-detail .curriculum ul li header").on("click", function(){
			const t = $(this).closest('li');
			if(t.hasClass('active'))t.removeClass('active');
			else{
				$(".course-detail .curriculum ul li.active").removeClass('active');
				t.addClass('active');
			}
		})
	}
	const wordContainer = $('.search-block .words .word');
	if(wordContainer.length>1){
		let ww = 0;
		wordContainer.each(function(){
			if($(this).width() > ww)ww = $(this).width();
			words.push($(this).text());
		});
		if(!$.isMobile)$('.search-block .words').width(ww + 10);
		wordContainer.remove();
		$(`<span class="text-wrapper">
      <span class="line line1"></span>
      <span class="letters">${words[0]}</span>
    </span>`).appendTo('.search-block .words');
		setupWord();
	}

	$('#header .nav > li').click(function (e) {
		e.stopPropagation();
	});
	$('#header .nav > li:has(.dropdown) > a').click(function (e) {
		e.preventDefault();
		const $this = $(this).closest('li');
		if($this.hasClass('active')){
			$this.removeClass('active');
		}
		else{
			$body.trigger('click.nav');
			const active = $('#header .nav > li.active');
			if(active.length)active.removeClass('active');
			$this.addClass('active');
			$body.one('click.nav', function () {
				$this.removeClass('active');
			});
		}

	});

	$('#header .lang > span').click(function (e) {
		e.preventDefault();
		e.stopPropagation();
		const $this = $(this).closest('.lang');
		if($this.hasClass('active')){
			$this.removeClass('active');
		}
		else{
			$body.trigger('click.nav');
			$this.addClass('active');
			$body.one('click.nav', function () {
				$this.removeClass('active');
			});
		}
	});


	if(['localhost:3000','hrcell.cdn.az'].includes(window.location.host)){
		$('.search-block form[action^="/index-search"] button[type="submit"]').click(function (e) {
			e.preventDefault();
			location.href = '/index-search.html';
		})

		$('.search-result .details .header .apply').click(function (e) {
			location.href = '/index-search-form.html';
		})
		$('.search-result .details .form .submit').click(function (e) {
			e.preventDefault();
			location.href = '/index-search-form-success.html';
		})
		$('.search-result .details .form-success .back').click(function (e) {
			e.preventDefault();
			location.href = '/index-search.html';
		})
		$('.contact .form .submit').click(function (e) {
			e.preventDefault();
			location.href = '/contact-success.html';
		})
		$('.course-form-modal .form .submit').attr('data-fancybox', '').attr('data-src', '#form-success-modal');
	}
});
const words = [];
let currentIndex = 0;
function setupWord() {
	// Mevcut kelimeyi al
	const currentWord = words[currentIndex];

	// HTML'i güncelle
	const textWrapper = document.querySelector('.search-block .letters');
	textWrapper.textContent = currentWord;
	textWrapper.innerHTML = textWrapper.textContent.replace(/([^\x00-\x80]|\w)/g, "<span class='letter'>$&</span>");

	// Animasyonu başlat
	const timeline = anime.timeline({loop: false})
		.add({
			targets: '.search-block .words .line',
			scaleY: [0,1],
			opacity: [0.5,1],
			easing: "easeOutExpo",
			duration: 700
		})
		.add({
			targets: '.search-block .words .line',
			translateX: [0, document.querySelector('.search-block .letters').getBoundingClientRect().width + 10],
			easing: "easeOutExpo",
			duration: 700,
			delay: 100
		}).add({
			targets: '.search-block .letter',
			opacity: [0,1],
			easing: "easeOutExpo",
			duration: 600,
			offset: '-=775',
			delay: (el, i) => 34 * (i+1)
		}).add({
			targets: '.search-block .words',
			opacity: 0,
			duration: 1000,
			easing: "easeOutExpo",
			delay: 1000,
			complete: function() {
				// Animasyon tamamlandığında
				// Bir sonraki kelimeye geç
				currentIndex = (currentIndex + 1) % words.length;

				// HTML'i sıfırla
				document.querySelector('.search-block .words').style.opacity = 1;
				document.querySelector('.search-block .words .line').style.transform = 'scaleY(0)';
				document.querySelector('.search-block .words .line').style.opacity = 0.5;
				document.querySelector('.search-block .words .line').style.translateX = '0px';

				// Sonraki kelimeyi hazırla
				setupWord();
			}
		});
}
$.isMobile = false;
const mobileSupport = (media) => {
	if (media.matches) {
		$.isMobile = true;
		setFooterFiexed();
		window.addEventListener('resize', setFooterFiexed);
		window.addEventListener('orientationchange', setFooterFiexed);
		$(document).trigger("mobileOn");
	} else {
		$.isMobile = false;

		$(document).trigger("mobileOff");
	}
};

function setFooterFiexed() {
	const footer = $('#footer');
	const h = footer.outerHeight();
	$('body').css('padding-bottom', h + 'px');
	footer.addClass('fixed');
}
function updateThemeOnHtmlEl(theme) {
	document.querySelector("html").setAttribute("data-theme", theme);
}
function calculateSettingAsThemeString(localStorageTheme, systemSettingDark) {
	if (localStorageTheme !== null) {
		return localStorageTheme;
	}

	if (systemSettingDark.matches) {
		return "dark";
	}

	return "light";
}
function updateButton(isDark) {
	if(isDark)$('#header .theme-toggle').addClass("dark");
	else $('#header .theme-toggle').removeClass("dark");
}